import React, { useEffect, useState } from 'react';
import Header from "./Header";
import {
    Button,
    Container,
    Row,
    Col,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

import settingsIcon from "assets/img/icons/common/settings-icon.svg";
import faqIcon from "assets/img/icons/common/faq-icon.svg";

import defaultAppImg from 'assets/img/brand/aircode-icon.png';
import { getImage, getAccountApps } from "../../../../network/ApiAxios";

import { faqData } from "../../LandingPage/FAQ/FAQData.js"
import { tipDataByRole } from "./TipsData.js"

import './Index.css'

// Componente Skeleton para os Apps
const AppSkeleton = () => (
    <Col xs="6" sm="4" md="3" lg="3" className='justify-content-center text-center mb-4'>
        <Row className='justify-content-center'>
            <div className='skeleton-pulse' style={{
                width: '120px',
                height: '120px',
                borderRadius: '26px',
                backgroundColor: '#e9ecef'
            }} />
        </Row>
        <Row className='justify-content-center pt-2'>
            <div className='skeleton-pulse' style={{
                width: '80px',
                height: '16px',
                borderRadius: '4px',
                backgroundColor: '#e9ecef'
            }} />
        </Row>
    </Col>
);

const Home = () => {
    const [apps, setApps] = useState([]);
    const [randomFAQ, setRandomFAQ] = useState(null);
    const [randomTip, setRandomTip] = useState(null);
    const [isLoading, setisLoading] = useState(false);
    const navigate = useNavigate();
    const user = JSON.parse(secureLocalStorage.getItem("user"));

    //Verifica o tipo de usuário retornado. Função auxiliar para filtrar o tipo de Dica vindo do TipsData.js
    const getUserRole = (user) => {
        const role = user?.credential?.type;
        if (!role) return null;
        if (role.isMaster) return "Master";
        if (role.isOwner) return "Owner";
        if (role.isADM) return "Adm";
        if (role.isTeacher) return "Teacher";
    }
    const role = getUserRole(user);

    useEffect(() => {
        document.title = 'FSK - Central System';
        const runAsync = async () => {
            setisLoading(true);
            const randomIndex = Math.floor(Math.random() * faqData.length);
            setRandomFAQ(faqData[randomIndex]);

            //Filtra e randomiza a dica do TipsData
            if (role && tipDataByRole[role]) {
                const tipsArray = tipDataByRole[role];
                const randomTipIndex = Math.floor(Math.random() * tipsArray.length);
                setRandomTip(tipsArray[randomTipIndex]);
            }

            let params = {
                filter: {
                    account: user.account
                }
            }

            const response = await getAccountApps(params);
            const { data } = response;

            if (data.success) {
                //carregando as imagens dos aplicativos
                let apps = data.account.apps
                for(let i=0; i<apps.length; i++) {
                    apps[i]['imageData'] = await getAppImage(apps[i])
                }

                setApps(data.account.apps)
            }
            setisLoading(false);
        }
        runAsync();
    }, []);

    let handleClick = (app) => {
        secureLocalStorage.setItem("app", JSON.stringify(app));
        navigate('/admin/appreport')
    }

    const getAppDisplayName = (app) => {
        const appName = app.name?.toLowerCase();

        if (appName?.includes('listen first')) {
            return 'Listen First';
        } else if (appName?.includes('elcar')) {
            return 'ELCAR System';
        } else {
            return app.name;
        }
    }

    const getAppImage = async (app) => {
        if (app?.image) {
            const response = await getImage(app?.image);
            const { data } = response;
            return data
        } else {
            return defaultAppImg;
        } 
    };

    return (
        <>
            <Header />
            <Container className='bg-white full-viewport-container px-4'>

                {/* Seção My Apps */}
                <Row className='justify-content-center'>
                    <div className='section-container w-75'>
                        <h3>My Apps</h3>
                        {!isLoading && apps.length === 0 && 
                            <div className='pl-4'>
                                <h4>You need to add an app to access the Central System and continue!</h4>
                                <p>Tap the '+' button to go to the store and add a license.</p>
                            </div>
                        }

                        <Row className='justify-content-left mb-5 pt-3'>
                            {isLoading ? (
                                // Skeleton durante carregamento
                                <>
                                    <AppSkeleton />
                                    <AppSkeleton />
                                    <AppSkeleton />
                                    <AppSkeleton />
                                </>
                            ) : (
                                // Conteúdo real
                                <>
                                    {apps.map((app, index) => (
                                        <Col xs="6" sm="4" md="3" lg="3" key={app._id} className='justify-content-center text-center mb-4 app-fade-in'>
                                            <Row className='justify-content-center'>
                                                <Button onClick={() => handleClick(app)}
                                                    type="button" className='app-btn'>
                                                    <img
                                                        src={app.imageData}
                                                        alt={getAppDisplayName(app)}
                                                        className="app-image"
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            borderRadius: 'inherit'
                                                        }}
                                                    />
                                                </Button>
                                            </Row>
                                            <Row className='justify-content-center pt-2'>
                                                <span className="btn-inner--text">{app.name}</span>
                                            </Row>
                                        </Col>
                                    ))}
                                    <Col xs="6" sm="4" md="3" lg="3" className='justify-content-center text-center mb-4 app-fade-in'>
                                        <Button className='add-app-btn shadow-none' onClick={() => { navigate('/home') }}>
                                            <span className='align-middle'>+</span>
                                        </Button>
                                    </Col>
                                </>
                            )}
                        </Row>
                    </div>
                </Row>

                {/* Seção FAQ */}
                <Row className='justify-content-center my-4'>
                    <div className='faq-section-container w-75'>
                        <Row className='justify-content-center mb-5 pt-3'>
                            <Col md="6" className='mb-4'>
                                <div className='faq-container' onClick={() => { navigate('/faq') }}>
                                    <div className='card-icon-top-right'>
                                        <img src={faqIcon} alt="FAQ Icon" />
                                    </div>
                                    <h3>{randomFAQ?.question} <i className='ni ni-bold-right' /></h3>
                                    <p>{randomFAQ?.answer}</p>
                                </div>
                            </Col>
                            <Col md="6" className='mb-4'>
                                <div className='faq-container' onClick={() => { apps?.length > 0 && navigate(randomTip.route) }}>
                                    <div className='card-icon-top-right'>
                                        <img src={settingsIcon} alt="Settings Icon" />
                                    </div>
                                    <h3>{randomTip?.title} <i className='ni ni-bold-right' /></h3>
                                    <p>{randomTip?.tip}</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Row>

            </Container>
        </>
    );
}

export default Home;